const translations = {
    delete: 'Delete All'
};

export default translations;
